<div class="map-shell" role="img" aria-label="Geographical summary map">
    <ng-container *ngIf="hasVisibleMapData; else fallbackMap">
        <svg class="map-svg" viewBox="0 0 1000 520" preserveAspectRatio="xMidYMid meet">
            <g *ngIf="showCountryLayer">
                <path *ngFor="let projected of projectedFeatures" class="map-country-shape" [attr.d]="projected.path"
                    [attr.fill]="getFill(projected.feature)" [attr.aria-label]="projected.feature.properties.name"
                    [class.map-country-selected]="projected.feature.properties.eicCountryId === selectedCountryId"
                    [class.map-country-disabled]="!isCountryInteractive(projected.feature)"
                    (mouseenter)="onCountryHovered(projected.feature, $event)"
                    (mousemove)="onCountryHovered(projected.feature, $event)" (mouseleave)="clearCountryHover()"
                    (click)="onFeatureClicked(projected.feature)">
                </path>
                <text *ngFor="let label of projectedCountryLabels" class="map-country-label" [attr.x]="label.x"
                    [attr.y]="label.y" text-anchor="middle" dominant-baseline="middle">
                    {{ label.name }}
                </text>
            </g>
            <g *ngIf="showRegionLayer">
                <path *ngFor="let projectedRegion of projectedRegionFeatures" class="map-region-shape"
                    [attr.d]="projectedRegion.path" [attr.fill]="getRegionFill(projectedRegion.feature)"
                    [class.map-region-selected]="projectedRegion.feature.properties.eicRegionId === selectedRegionId"
                    (mouseenter)="onRegionHovered(projectedRegion.feature)"
                    (mousemove)="onRegionHovered(projectedRegion.feature)" (mouseleave)="clearRegionHover()"
                    (click)="onRegionFeatureClicked(projectedRegion.feature)">
                </path>
                <text *ngFor="let label of projectedRegionLabels" class="map-region-label" [attr.x]="label.x"
                    [attr.y]="label.y" text-anchor="middle" dominant-baseline="middle">
                    <tspan *ngFor="let line of label.lines; let i = index" [attr.x]="label.x"
                        [attr.dy]="i === 0 ? 0 : 10">
                        {{ line }}
                    </tspan>
                </text>
            </g>
        </svg>
        <div class="map-tooltip" *ngIf="hoveredCountry" [style.left.px]="hoveredCountry.x + 14"
            [style.top.px]="hoveredCountry.y + 14">
            {{ hoveredCountry.name }}
        </div>
    </ng-container>

    <ng-template #fallbackMap>
        <div class="map-empty-state">
            Map geometry is unavailable.
        </div>
    </ng-template>
</div>